import { createRoute, redirect } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { mediaPlatformSpacesRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Routing'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space'
import { mediaPlatformSpacePermissionsUsersOverviewRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space/Permissions'

export const mediaPlatformSpaceRoute = createRoute({
  getParentRoute: () => mediaPlatformSpacesRoute,
  path: DynamicRouteParameterWPrefix.SPACE_ID,
  beforeLoad: ({ location, params }) => {
    if (location.pathname.endsWith(params.spaceId) || location.pathname.endsWith(`${params.spaceId}/`)) {
      throw redirect({
        replace: true,
        from: mediaPlatformSpaceRoute.fullPath,
        to: mediaPlatformSpacePermissionsUsersOverviewRoute.to,
      })
    }
  },
  loader: () => ({
    crumb: t('entity:publishing.space', { count: 1 }),
  }),
})

export const mediaPlatformSpaceLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformSpaceRoute,
  id: 'mediaPlatformSpaceLayout',
  component: () => <Structure />,
})
